
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HeaderLogo',

  computed: {
    headerLogo() {
      return this.$store.getters['Config/getHeaderLogo'];
    }
  }
});
